import React, { useState, useEffect } from 'react';
import { t } from 'i18next';
//import ats from './data';

const HeroIntro = () => {
    //const { feature_cards } = ats;
    const [isLoaded, setIsLoaded] = useState(false);
    
    useEffect(() => {
        // Trigger animation after component mounts
        setIsLoaded(true);
    }, []);

    return (
        <div className="overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 py-12 sm:pt-16 lg:px-8 lg:pt-8">
              <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center text-left">
                <div className="relative w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                <h2 className="text-2xl font-semibold leading-7 text-red-600">{t('welcome_to')}</h2>
                  <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                  ATS Auto Detail &amp; Sales
                  </h1>
                  <p className="mt-4 text-lg leading-7 text-gray-600 sm:max-w-md lg:max-w-none">
                  {t('hero_intro')}
                  </p>
                  <div className="mt-6 flex items-center gap-x-6">
                    <a
                      href="/inventory"
                      className="rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Find your next car <span aria-hidden="true">→</span>
                    </a>
                  </div>
                </div>
                
                <div id='stacked-stock-cards' className="mt-10 lg:mt-0 perspective-600 flex-shrink-0">
                  <div className="flex flex-row items-center justify-center space-x-[-60px]">
                    <div 
                      className="relative w-48 transform transition-all duration-700 shadow-lg" 
                      style={{
                        transform: `rotateY(20deg) rotateX(10deg) rotateZ(6deg) translateY(${isLoaded ? '0' : '-20px'})`,
                        opacity: isLoaded ? 1 : 0,
                        zIndex: 5,
                        transitionDelay: '100ms'
                      }}
                    >
                      <img
                        alt="ATS Auto Detail & Sales"
                        src="https://ats.limestripes.com/wp-content/uploads/2025/03/ats_herocard_1-768x1365.jpg"
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        loading='lazy'
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    
                    <div 
                      className="relative w-48 transform transition-all duration-700 shadow-lg" 
                      style={{
                        transform: `rotateY(20deg) rotateX(5deg) rotateZ(10deg) translateY(${isLoaded ? '0' : '-20px'})`,
                        opacity: isLoaded ? 1 : 0,
                        zIndex: 4,
                        transitionDelay: '200ms'
                      }}
                    >
                      <img
                        alt="ATS Auto - Denver"
                        src="https://ats.limestripes.com/wp-content/uploads/2025/03/ats_herocard_4-768x1365.jpg"
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        loading='lazy'
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    
                    <div 
                      className="relative w-48 transform transition-all duration-700 shadow-lg" 
                      style={{
                        transform: `rotateY(20deg) rotateX(5deg) rotateZ(12deg) translateY(${isLoaded ? '0' : '-20px'})`,
                        opacity: isLoaded ? 1 : 0,
                        zIndex: 2,
                        transitionDelay: '300ms'
                      }}
                    >
                      <img
                        alt="ATS Auto - Denver, CO"
                        src="https://ats.limestripes.com/wp-content/uploads/2025/03/ats_herocard_3-768x1365.jpg"
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        loading='lazy'
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    
                    <div 
                      className="relative w-48 transform transition-all duration-700 shadow-lg" 
                      style={{
                        transform: `rotateY(20deg) rotateX(5deg) rotateZ(15deg) translateY(${isLoaded ? '0' : '-20px'})`,
                        opacity: isLoaded ? 1 : 0,
                        zIndex: 1,
                        transitionDelay: '400ms'
                      }}
                    >
                      <img
                        alt="ATS Auto - Denver, CO"
                        src='https://ats.limestripes.com/wp-content/uploads/2025/03/ats_herocard_2-768x1365.jpg'
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        loading='lazy'
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="mt-10 border-t border-gray-200" />
          </div>
    );
};

export default HeroIntro;